// extracted by mini-css-extract-plugin
export default {"auth-page":"auth-page__CNlLy","auth-container":"auth-container__bn20H","auth-form":"auth-form__mmFOl","primaryButton":"primaryButton__SU0BT"};